(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aq-engine"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqRevealInit) return;
    window.__aqRevealInit = true;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function assignStaggerIndex(root) {
      root.querySelectorAll('[data-aq-stagger-group]').forEach(function (group) {
        group.querySelectorAll('.aq-reveal').forEach(function (el, i) {
          el.style.setProperty('--aq-stagger-index', i);
        });
      });
    }

    function reveal(el) {
      el.classList.add('aq-reveal--visible');
    }

    var observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  reveal(entry.target);
                  observer.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
          )
        : null;

    function observeAll() {
      assignStaggerIndex(document);
      document.querySelectorAll('.aq-reveal:not(.aq-reveal--visible)').forEach(function (el) {
        if (prefersReduced || !observer) {
          reveal(el);
        } else {
          observer.observe(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
    document.addEventListener('shopify:section:load', observeAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aq-mercadopago-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqMpInit) return;
    window.__aqMpInit = true;

    function findForm(root) {
      return root.closest('.shopify-section')
        ? root.closest('.shopify-section').querySelector('form[action*="/cart/add"]')
        : document.querySelector('form[action*="/cart/add"]');
    }

    function nativeAddToCartButton(section) {
      return section ? section.querySelector('[data-add-to-cart-button], button[name="add"]') : null;
    }

    function syncDisabled(root) {
      var section = root.closest('.shopify-section');
      var btn = root.querySelector('[data-aq-mp-button]');
      var nativeBtn = nativeAddToCartButton(section);
      if (!btn) return;
      if (nativeBtn) {
        btn.disabled = nativeBtn.disabled;
      } else {
        btn.disabled = false;
      }
    }

    function init(root) {
      if (root.__aqMpBound) return;
      root.__aqMpBound = true;

      var btn = root.querySelector('[data-aq-mp-button]');
      var label = root.querySelector('[data-aq-mp-label]');
      var errorEl = root.querySelector('[data-aq-mp-error]');
      var defaultLabel = label.innerHTML;
      var busy = false;

      syncDisabled(root);

      var section = root.closest('.shopify-section');
      if (section) {
        section.addEventListener('variant:update', function () {
          syncDisabled(root);
        });
      }

      btn.addEventListener('click', function () {
        if (busy || btn.disabled) return;

        var form = findForm(root);
        if (!form) return;

        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var variantId = idInput ? idInput.value : null;
        var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;

        if (!variantId) return;

        busy = true;
        errorEl.hidden = true;
        btn.disabled = true;
        label.textContent = 'Procesando…';

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
            });
          })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'cart/add failed');
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('[aq-mercadopago-buy-now]', err);
            busy = false;
            btn.disabled = false;
            label.innerHTML = defaultLabel;
            errorEl.hidden = false;
          });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-aq-mp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aq-notify"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqNotifyInit) return;
    window.__aqNotifyInit = true;

    function run(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-aq-notify-item]'));
      if (!items.length) return;
      var i = 0;

      function hide(el) {
        el.classList.remove('aq-notify__toast--visible');
      }

      function show(el) {
        el.classList.add('aq-notify__toast--visible');
        var seconds = parseInt(el.getAttribute('data-interval'), 10) || 12;
        window.setTimeout(function () {
          hide(el);
          window.setTimeout(next, 600);
        }, Math.max(seconds, 4) * 1000);
      }

      function next() {
        show(items[i % items.length]);
        i++;
      }

      items.forEach(function (el) {
        var closeBtn = el.querySelector('[data-aq-notify-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            hide(el);
          });
        }
      });

      window.setTimeout(next, 2500);
    }

    document.querySelectorAll('[data-aq-notify]').forEach(run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["aq-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aqPriceInit) return;
    window.__aqPriceInit = true;

    function bind(el) {
      if (el.__aqPriceBound) return;
      el.__aqPriceBound = true;
      var section = el.closest('.shopify-section');
      if (!section) return;

      section.addEventListener('variant:update', function (event) {
        var detail = event.detail;
        if (!detail || !detail.data || !detail.data.html) return;
        var blockId = el.getAttribute('data-block-id');
        var newInner = detail.data.html.querySelector(
          '[data-aq-price][data-block-id="' + blockId + '"] [data-aq-price-inner]'
        );
        var currentInner = el.querySelector('[data-aq-price-inner]');
        if (newInner && currentInner) {
          currentInner.replaceWith(newInner);
        }
      });
    }

    function bindAll() {
      document.querySelectorAll('[data-aq-price]').forEach(bind);
    }

    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ff-faq-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ffFaqInit) return;
    window.__ffFaqInit = true;

    // Nota: se evita requestAnimationFrame para disparar la transición.
    // rAF se pausa por completo cuando la pestaña no está visible/enfocada,
    // lo que podía dejar una pregunta "atascada" a medio abrir/cerrar. En su
    // lugar se usa el truco clásico de forzar un reflow síncrono (lectura de
    // offsetHeight) entre el valor inicial y el valor final, que sí funciona
    // sin depender del scheduler de animación. Además, cada apertura/cierre
    // tiene un timeout de respaldo que garantiza el estado final aunque por
    // algún motivo 'transitionend' no llegue a disparar (pestaña oculta,
    // prefers-reduced-motion, etc.), evitando que el acordeón quede en un
    // estado inconsistente.
    function openDetails(details) {
      details.setAttribute('open', '');
      var content = details.querySelector('.ff-faq__answer');
      var inner = details.querySelector('.ff-faq__answer-inner');
      if (!content || !inner) return;
      var targetHeight = inner.scrollHeight;

      content.style.height = '0px';
      // Forzar reflow para que el navegador registre el 0px como punto de
      // partida antes de aplicar el valor final.
      // eslint-disable-next-line no-unused-expressions
      content.offsetHeight;
      content.style.height = targetHeight + 'px';

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        content.style.height = 'auto';
        content.removeEventListener('transitionend', onEnd);
        clearTimeout(fallback);
      }
      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        finish();
      }
      content.addEventListener('transitionend', onEnd);
      var fallback = setTimeout(finish, 400);
    }

    function closeDetails(details) {
      var content = details.querySelector('.ff-faq__answer');
      var inner = details.querySelector('.ff-faq__answer-inner');
      if (!content || !inner) return;
      var currentHeight = inner.scrollHeight;
      content.style.height = currentHeight + 'px';

      // Force reflow so the browser registers the explicit height
      // before collapsing to 0, otherwise the transition is skipped.
      // eslint-disable-next-line no-unused-expressions
      content.offsetHeight;

      content.style.height = '0px';

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        details.removeAttribute('open');
        content.removeEventListener('transitionend', onEnd);
        clearTimeout(fallback);
      }
      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        finish();
      }
      content.addEventListener('transitionend', onEnd);
      var fallback = setTimeout(finish, 400);
    }

    function setup(list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.ff-faq__item'));
      items.forEach(function (details) {
        var summary = details.querySelector('summary.ff-faq__question');
        if (!summary) return;
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          var isOpen = details.hasAttribute('open');

          items.forEach(function (other) {
            if (other !== details && other.hasAttribute('open')) {
              closeDetails(other);
            }
          });

          if (isOpen) {
            closeDetails(details);
          } else {
            openDetails(details);
          }
        });
      });
    }

    document.querySelectorAll('[data-ff-faq-list]').forEach(setup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ff-price-hero"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ffPriceInit) return;
    window.__ffPriceInit = true;

    function bind(el) {
      if (el.__ffPriceBound) return;
      el.__ffPriceBound = true;
      var section = el.closest('.shopify-section');
      if (!section) return;

      section.addEventListener('variant:update', function (event) {
        var detail = event.detail;
        if (!detail || !detail.data || !detail.data.html) return;
        var blockId = el.getAttribute('data-block-id');
        var newInner = detail.data.html.querySelector(
          '[data-ff-price][data-block-id="' + blockId + '"] [data-ff-price-inner]'
        );
        var currentInner = el.querySelector('[data-ff-price-inner]');
        if (newInner && currentInner) {
          currentInner.replaceWith(newInner);
        }
      });
    }

    function bindAll() {
      document.querySelectorAll('[data-ff-price]').forEach(bind);
    }

    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
